import styled from "styled-components";

const StatBox = ({ title, component }) => {
  return (
    <>
      <Container>
        <Box>
          <Body className="gradient-gray-light heading">{component}</Body>
          <Title className="fw-bold">{title}</Title>
        </Box>
      </Container>
    </>
  );
};
export default StatBox;
const Container = styled.div`
  width: 25%;
  height: 80px;
  margin-top: 1rem;

  border-radius: 8px;
  /* background-color: rgb(74, 74, 74); */
`;
const Box = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const Body = styled.div`
  background: linear-gradient(135deg, #000000 0%, #001a4d 40%, #0d47a1 50%, #001a4d 60%, #000000 100%);
  width: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 65%;
  border-radius: 8px;
  border: 0.5px solid gray;
  box-shadow: 0 0 5px rgba(0, 157, 255, 1), inset 0 0 10px rgba(8, 10, 127, 1);

  /* background-image: linear-gradient(
    to top,
    rgba(74, 74, 74, 1),
    10%,
    transparent
  ); */
`;
const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 35%;
`;
